<template>
    <input
        ref="inputRef"
        type="text"
        :id="id"
        :name="name"
        class="currency-input"
    />
</template>

<script>
import { watch } from "vue";
import { useCurrencyInput } from "vue-currency-input";
import { watchDebounced } from "@vueuse/core";

export default {
    name: "CurrencyInput",
    props: {
        value: Number | String, // Vue 2: value
        options: Object,
        id: String,
        name: String,
    },
    setup(props, { emit }) {
        const { inputRef, numberValue, setValue } = useCurrencyInput(
            {
                locale: "en",
                currency: "USD",
                hideCurrencySymbolOnFocus: false,
                hideGroupingSeparatorOnFocus: false,
                hideNegligibleDecimalDigitsOnFocus: false,
                currencyDisplay: "symbol",
            },
            false
        );

        watch(
            () => props.value, // Vue 2: props.value
            (value) => {
                setValue(value);
            }
        );

        watchDebounced(numberValue, (value) => emit("input", value), {
            debounce: 100,
        });

        return { inputRef };
    },
};
</script>
